<template>
  <div class="home py-5">
        <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wineTemplate.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineBottleImage
        resource="wine-templates"
        :id="wineTemplate.id"
        :APIbaseURL="APIbaseURL"
      />
      <AveineWineTemplateForm :APIbaseURL="APIbaseURL" :wineTemplate="wineTemplate" :adminMode="true" :toSave="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineWineTemplateForm } from 'aveine-wine';
import AveineBottleImage from '@/components/AveineBottleImage.vue'
import { WineTemplate } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      wineTemplate: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Update',
  components: {
    AveineWineTemplateForm,
    AveineBottleImage
  },
  async beforeCreate() {
    try {
      await WineTemplate.api().get(`wine-templates/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
        params: {
          include:
            'grapes-composes-wine-template.grape.grape-variety,' +
            'wines.wine-labels,' +
            'appellation,' +
            'region,' +
            'country,' +
            'domain.region.country',
        }
      });

      this.wineTemplate = await WineTemplate.query().whereId(this.$route.params.id).withAllRecursive().first();
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
